module.exports = __webpack_public_path__ + "img/crusher.63fd4ec3.png";